const env = process.env

window.General = {};

window.General.StripePublishablekey = env.REACT_APP_STRIPE_PUBLIC_KEY

